// ⭐ Jumia seller score next to a store name (user 2026-10-25: "show the score of each store, especially on the scanner
// and the orders page"). One request per page load, shared by every chip (GET /profit/store-scores).
// Green ≥ 4 · orange 3.5–4 · red < 3.5. Marjane / Shopify stores have no score → nothing shown.
import { FC, useContext, useEffect, useState } from 'react';
import axios from 'axios';
import ContextStore from '../../hooks/ContextStore';
import { urls } from '../../dispatch/urls';

type Scores = Record<string, { score: number | null; weak: string[]; updatedAt: string | null }>;
let cache: Promise<Scores> | null = null; let cachedAt = 0;
const load = (token: string) => {
  if (!cache || Date.now() - cachedAt > 30 * 60000) {
    cachedAt = Date.now();
    cache = axios.get(`${urls.baseUrlRestApi}/profit/store-scores`, { headers: { 'x-auth-token': token } }).then((r) => r.data.scores || {}).catch(() => { cache = null; return {}; });
  }
  return cache;
};
const norm = (s: string) => s.trim().toUpperCase();

export const StoreScoreChip: FC<{ store: string | null | undefined; size?: 'sm' | 'md' }> = ({ store, size = 'sm' }) => {
  const { contextStore } = useContext(ContextStore);
  const [scores, setScores] = useState<Scores | null>(null);
  useEffect(() => { let alive = true; load(contextStore?.token || '').then((s) => alive && setScores(s)); return () => { alive = false; }; }, [contextStore?.token]);
  if (!store || !scores) return null;
  const key = Object.keys(scores).find((k) => norm(k) === norm(store));
  const s = key ? scores[key] : null;
  if (!s || s.score == null) return null;
  const tone = s.score >= 4 ? { bg: '#dcfce7', fg: '#166534' } : s.score >= 3.5 ? { bg: '#fef3c7', fg: '#92400e' } : { bg: '#fee2e2', fg: '#b91c1c' };
  const title = `Jumia seller score ${s.score.toFixed(2)}${s.weak.length ? ` — pulled down by: ${s.weak.join(', ')}` : ''}`;
  return (
    <span title={title} dir="ltr" style={{ display: 'inline-flex', alignItems: 'center', gap: 2, background: tone.bg, color: tone.fg, borderRadius: 999, padding: size === 'md' ? '1px 8px' : '0 6px', fontSize: size === 'md' ? 13 : 11, fontWeight: 800, whiteSpace: 'nowrap', marginInlineStart: 4, verticalAlign: 'middle', lineHeight: 1.5 }}>
      ⭐ {s.score.toFixed(2)}
    </span>
  );
};
export default StoreScoreChip;
